import { PropsWithChildren } from 'react';

import { Compose } from '../helpers/Compose';
import { ClientContextProvider } from './client';
import { InfoErrorContextProvider } from './infoError';
import { OrganizationContextProvider } from './organization';
import { ProjectContextProvider } from './project';
import { SelectionContextProvider } from './selection';
import { SupervisorContextProvider } from './supervisor';
import { TranslationsContextProvider } from './translations';
import { UserContextProvider } from './user';
import { VehicleContextProvider } from './vehicle';
import { WebhookContextProvider } from './webhook';

export const AppContextProvider = ({ children }: PropsWithChildren) => (
  <Compose
    components={[
      ClientContextProvider,
      InfoErrorContextProvider,
      OrganizationContextProvider,
      ProjectContextProvider,
      SelectionContextProvider,
      TranslationsContextProvider,
      UserContextProvider,
      VehicleContextProvider,
      SupervisorContextProvider,
      WebhookContextProvider,
    ]}
  >
    {children}
  </Compose>
);
